<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-body">
          <div class="container">
            <h2 class="title mb-3">Quyền và trách nhiệm của Thành viên</h2>
            <!-- <h4>I. QUYỀN VÀ TRÁCH NHIỆM CỦA BAN QUẢN LÝ TRANG VÀNG DU LỊCH VIỆT NAM</h4>
            <h4>1. Quyền của Ban Quản lý Trang vàng Du lịch Việt Nam</h4>
            <ul>
                <li>Ban Quản lý Trang vàng Du lịch Việt Nam có quyền yêu cầu các thành viên tham gia hoạt động trên Trang vàng Du lịch Việt Nam hoàn thành các thủ tục, các điều kiện cam kết liên quan.</li>
                <li>Ban Quản lý Trang vàng Du lịch Việt Nam có quyền/</li>
                <li>Ban Quản lý Trang vàng Du lịch Việt Nam có quyền từ chối hoặc ngừng cung cấp dịch vụ cho thành viên khi phát hiện thành viên cung cấp thông tin sai lệch, không đầy đủ hoặc vi phạm thuần phong mỹ tục cũng như quy định pháp luật Việt Nam.</li>
                <li>Ban Quản lý Trang vàng Du lịch Việt Nam được toàn quyền chấm dứt quyền thành viên và sử dụng dịch vụ khi phát hiện thành viên vi phạm pháp luật, có hành vi lừa đảo, hành vi giả mạo gây ảnh hưởng đến những thành viên khác, hoặc phá sản.</li>
                <li>Ban Quản lý Trang vàng Du lịch Việt Nam được quyền sử dụng thông tin cho các mục đích chính đáng hỗ trợ quảng bá du lịch, phục vụ công tác quản lý và phát triển du lịch Việt Nam.</li>
            </ul>
            <h4>2. Nghĩa vụ và trách nhiệm của Ban Quản lý Trang vàng Du lịch Việt Nam</h4>
            <ul>
                <li>Tiến hành đăng ký trực tuyến với Bộ Công Thương về việc thiết lập website cung cấp dịch vụ thương mại điện tử sau khi website đã được hoàn thiện với đầy đủ cấu trúc, tính năng và thông tin theo đề án cung cấp dịch vụ, đã hoạt động tại địa chỉ tên miền được đăng ký và trước khi chính thức cung cấp dịch vụ đến người dùng.</li> -->
                <!--<li>Yêu cầu Nhà cung cấp dịch vụ tham gia Trang vàng Du lịch Việt Nam cung cấp thông tin theo quy định tại Điều 29 Nghị định số 52/2013/NĐ-CP khi đăng ký tham gia. Bao gồm:</li>
                 <li>Tuân thủ quy định của pháp luật có liên quan về thanh toán, quảng cáo, khuyến mại.</li>
                <li>Bảo mật và lưu giữ và mọi hoạt động sử dụng dịch vụ dưới tên đăng ký, mật khẩu và hộp thư điện tử của mình.</li>
                <li>Thông báo kịp thời cho website Trang vàng Du lịch Việt Nam về những hành vi sử dụng trái phép, lạm dụng, vi phạm bảo mật, lưu giữ tên đăng ký và mật khẩu của bên thứ ba để có biện pháp xử lý kịp thời.</li>
                <li>Cung cấp thông tin cho website Trang vàng Du lịch Việt Nam và đăng tải, cập nhật những thông tin trên website đầy đủ và chính xác, đặc biệt thông tin về giá cả và chất lượng sản phẩm mà thành viên cung cấp.</li>
                <li>Không sử dụng dịch vụ của website Trang vàng Du lịch Việt Nam vào những mục đích bất hợp pháp, không hợp lý, lừa đảo, đe doạ, thăm dò thông tin bất hợp pháp, phá hoại, tạo ra và phát tán virus gây hư hại tới hệ thống, cấu hình, truyền tải thông tin của website Trang vàng Du lịch Việt Nam hay sử dụng dịch vụ của mình vào mục đích đầu cơ, lũng đoạn thị trường tạo những đơn đặt hàng, chào hàng giả, kể cả phục vụ cho việc phán đoán nhu cầu thị trường. Trong trường hợp vi phạm thì thành viên phải chịu trách nhiệm về các hành vi của mình trước pháp luật.</li>
                <li>Không được hành động gây mất uy tín của website Trang vàng Du lịch Việt Nam dưới mọi hình thức như gây mất đoàn kết giữa các thành viên bằng cách sử dụng tên đăng ký thứ hai, thông qua một bên thứ ba hoặc tuyên truyền, phổ biến những thông tin không có lợi cho uy tín của website Trang vàng Du lịch Việt Nam.</li> -->
                <!-- <li>
                    Yêu cầu Nhà cung cấp dịch vụ tham gia Trang vàng Du lịch Việt Nam cung cấp thông tin theo quy định tại Điều 29 Nghị định số 52/2013/NĐ-CP khi đăng ký tham gia. Bao gồm:
                    <ul>
                        <li>Tên và địa chỉ trụ sở của nhà cung cấp dịch vụ; hoặc tên và địa chỉ thường trú của cá nhân đại diện nhà cung cấp dịch vụ;</li>
                        <li>Giấy đăng ký kinh doanh, số, ngày cấp và nơi cấp giấy chứng nhận đăng ký kinh doanh; hoặc số, ngày cấp và đơn vị cấp quyết định thành lập của tổ chức, hoặc mã số thuế cá nhân đại diện.</li>
                        <li>Thông tin về điều kiện giao dịch chung</li>
                        <li>Số điện thoại hoặc một phương thức liên hệ trực tuyến khác.</li>
                    </ul>
                </li>
                <li>Công bố công khai trên TRANG CHỦ website Quy chế hoạt động của Trang vàng Du lịch Việt Nam theo quy định tại Điều 38 Nghị định số 52/2013/NĐ-CP; theo dõi và bảo đảm việc thực hiện quy chế.</li>
                <li>Kiểm tra, giám sát để đảm bảo việc cung cấp thông tin của Nhà cung cấp dịch vụ trên Trang vàng Du lịch Việt Nam được thực hiện chính xác, đầy đủ.</li>
                <li>Lưu trữ thông tin đăng ký của các tổ chức, cá nhân tham gia Trang vàng Du lịch Việt Nam và thường xuyên cập nhật những thông tin thay đổi, bổ sung có liên quan.</li>
                <li>Áp dụng các biện pháp cần thiết để đảm bảo an toàn thông tin liên quan đến bí mật kinh doanh của tổ chức, cá nhân và thông tin cá nhân của thành viên.</li>
                <li>Có biện pháp xử lý kịp thời khi phát hiện hoặc nhận được phản ánh về hành vi kinh doanh vi phạm pháp luật trên Trang vàng Du lịch Việt Nam.</li>
                <li>Hỗ trợ cơ quan quản lý nhà nước điều tra các hành vi kinh doanh vi phạm pháp luật, cung cấp thông tin đăng ký, lịch sử giao dịch và các tài liệu khác về đối tượng có hành vi vi phạm pháp luật trên Trang vàng Du lịch Việt Nam.</li>
                <li>Công bố công khai cơ chế giải quyết các tranh chấp phát sinh trong quá trình giao dịch trên Trang vàng Du lịch Việt Nam, tích cực hỗ trợ du khách bảo vệ quyền và lợi ích hợp pháp.</li>
            </ul> -->
            <h4>1. Quyền của Thành viên tham gia Trang vàng Du lịch Việt Nam</h4>
              <ul>
                <li>Sau khi đăng ký, Thành viên được cấp tài khoản có mật khẩu riêng để sử dụng, hoạt động trên Trang vàng Du lịch Việt Nam.</li>
                <li>Thành viên sẽ được hướng dẫn sử dụng những công cụ tiện ích cho đăng tin (dành cho Nhà cung cấp dịch vụ) trên Trang vàng Du lịch Việt Nam, phản ánh (dành cho Du khách).</li>
                <li>Thành viên có quyền đóng góp ý kiến cho Trang vàng Du lịch Việt Nam về toàn bộ quy trình, giải pháp nâng cao hiệu quả… bằng cách gửi email.</li>
              </ul>
            <h4 class="mt-2">2. Nghĩa vụ và trách nhiệm của Thành viên tham gia Trang vàng Du lịch Việt Nam</h4>
              <ul>
              <li>
                Nhà cung cấp dịch vụ phải cung cấp đầy đủ và chính xác các thông tin theo quy định tại Điều 29 Nghị định số 52/2013/NĐ-CP khi đăng ký tham gia Trang vàng Du lịch Việt Nam. Bao gồm:
                <ul>
                  <li>Tên và địa chỉ trụ sở của nhà cung cấp dịch vụ; hoặc tên và địa chỉ thường trú của cá nhân đại diện nhà cung cấp dịch vụ;</li>
                  <li>Giấy đăng ký kinh doanh, số, ngày cấp và nơi cấp giấy chứng nhận đăng ký kinh doanh; hoặc số, ngày cấp và đơn vị cấp quyết định thành lập của tổ chức, hoặc mã số thuế cá nhân đại diện.</li>
                  <li>Số điện thoại hoặc một phương thức liên hệ trực tuyến khác.</li>
                </ul>
              </li>
              <li>Nhà cung cấp dịch vụ phải cung cấp đầy đủ thông tin về sản phẩm, dịch vụ theo quy định để du khách có thể xác định chính xác các đặc tính của sản phẩm, dịch vụ nhằm tránh sự hiểu nhầm khi quyết định việc đề nghị giao kết hợp đồng. Trong đó, thông tin về giá cả (nếu có) phải thể hiện rõ giá đó đã bao gồm hay chưa bao gồm những chi phí liên quan như thuế, phí và các chi phí phát sinh khác.</li>
              <li>Nhà cung cấp dịch vụ chịu trách nhiệm đảm bảo tính chính xác, trung thực của thông tin về sản phẩm, dịch vụ cung cấp trên Trang vàng Du lịch Việt Nam.</li>
              <li>Nhà cung cấp dịch vụ có trách nhiệm cung cấp thông tin về tình hình kinh doanh của mình khi có yêu cầu của cơ quan nhà nước có thẩm quyền để phục vụ hoạt động thống kê thương mại điện tử.</li>
              <li>Nhà cung cấp dịch vụ có trách nhiệm tuân thủ quy định của pháp luật về thanh toán, quảng cáo, khuyến mại, bảo vệ quyền sở hữu trí tuệ, bảo vệ quyền lợi người tiêu dùng và các quy định của pháp luật có liên quan khác khi cung ứng dịch vụ trên Trang vàng Du lịch Việt Nam.</li>
              <li>Nhà cung cấp dịch vụ chịu trách nhiệm về nội dung, hình ảnh, thông tin do Nhà cung cấp dịch vụ đăng tải. Nhà cung cấp dịch vụ cam kết không đăng tải những thông tin vi phạm pháp luật, những nội dung ảnh hưởng đến bản quyền, sở hữu trí tuệ.</li>
              <li>Nhà cung cấp dịch vụ có trách nhiệm bồi thường thiệt hại cho Du khách nếu phát hiện lỗi đó thuộc về Nhà cung cấp dịch vụ.</li>
              <li>Nhà cung cấp dịch vụ có trách nhiệm thực hiện đầy đủ nghĩa vụ thuế theo quy định của pháp luật.</li>
              <li>Thành viên tự chịu trách nhiệm về bảo mật và lưu giữ những hoạt động trong quá trình sử dụng Trang vàng Du lịch Việt Nam, bao gồm cả mật khẩu và tài khoản. Thành viên có trách nhiệm thông báo kịp thời cho Trang vàng Du lịch Việt Nam hành vi lạm dụng trái phép, vi phạm bảo mật và lưu giữ về thông tin đăng ký và mật khẩu tài khoản để hợp tác xử lý kịp thời.</li>
              <li>Thành viên có trách nhiệm tiếp nhận, cung cấp thông tin và bằng chứng xác thực, tích cực phối hợp xử lý khi xảy ra tranh chấp, khiếu nại.</li>
              <li>Thành viên cam kết không sử dụng các tiện ích của Trang vàng Du lịch Việt Nam vào những mục đích bất hợp pháp, lừa đảo, đe dọa, thăm dò thông tin bất hợp pháp, phá hoại gây ảnh hưởng đến hệ thống; truyền tải thông tin vào những mục đích vi phạm pháp luật. Trong trường hợp vi phạm, thành viên phải tự chịu trách nhiệm trước pháp luật.</li>
              <li>Thành viên cam kết không truyền bá những thông tin bất lợi, không hành động gây mất uy tín của Trang vàng Du lịch Việt Nam dưới mọi hình thức.</li>
            </ul>
            <template v-if="isAccountDuLichJoin">
              <el-checkbox
                v-model="mData.isReadTerm"
                style="margin-left: 40px;"
              >Đồng ý</el-checkbox>
              <div class="text-center">
                <el-button
                  type="primary"
                  :disabled="!mData.isReadTerm"
                  @click="checkEndow"
                >Tham gia</el-button>
              </div>

            </template>
          </div>
      </div>
    </div>
    <!-- Dialog nhập thông tin khuyến mãi -->
    <el-dialog
      title="Cập nhật thông tin ưu đãi"
      :visible.sync="dialogEndow"
      top="90px"
      width="30%"
      class="endow"
      :before-close="handleClose"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form
        :model="mData.dataFormEndow"
        :rules="mData.validFormEndow"
        ref="endowForm"
        label-width="120px"
        label-position="top"
      >
        <el-form-item label="Loại ưu đãi" prop="loai_hinh_uu_dai">
          <el-select
            v-model="mData.dataFormEndow.loai_hinh_uu_dai"
            placeholder="Chọn loại hình ưu đãi"
            clearable
            @change="changeTypeEndow(mData.dataFormEndow.loai_hinh_uu_dai)"
          >
            <el-option
              v-for="item in mData.listLoaiHinhUuDai"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Giá trị ưu đãi" prop="gia_tri_uu_dai">
          <ElementUiMoney
            v-model="mData.dataFormEndow.gia_tri_uu_dai"
            label=""
            :placeholder="'Nhập giá trị ưu đãi'"
            :outlined="true"
            :clearable="true"
          />
        </el-form-item>
        <div class="text-center">
          <el-button type="primary" @click="updateEndow()">Cập nhật</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import AuthService from "../../../service/AuthService";
import LanguageService from '../../../service/LanguageService';
import MethodService from '../../../service/MethodService';
import ValidService from '../../../service/ValidService';
import DDATApi from '@/moduleApi/DDATApi';
import DonViCungCapChoDuyetApi from '@/moduleApi/DonViCungCapChoDuyetApi';
import DonViCungCapApi from '@/moduleApi/DonViCungCapApi';
import ElementUiMoney from '@/component/ElementUiMoney';

export default {
  components: {
    ElementUiMoney
  },
  data() {
    return {
      dialogEndow: false,
      isAccountDuLichJoin: false,
      mData: {
        isReadTerm: false,
        infoDDAT: null,
        dataFormEndow: {
          loai_hinh_uu_dai: undefined,
          gia_tri_uu_dai: undefined
        },
        validFormEndow: {
          loai_hinh_uu_dai: [ValidService.requiredChange],
          gia_tri_uu_dai: [ValidService.required]
        },
        listLoaiHinhUuDai: [
          {
            value: "giam_gia_tien",
            label: "Giảm giá tiền"
          },
          {
            value: "giam_gia_phan_tram",
            label: "Giảm giá phần trăm"
          }
        ]
      }
    }
  },
  methods: {
    handleClose(done){
      done();
    },
    validatePercent(rule, value, callback){
      if (value > 100) {
        callback(new Error("Phần trăm không quá 100%"))
      } else {
        callback()
      }
    },
    checkEndow(){
      if (!this.infoDDAT.thong_tin_chung.loai_hinh_uu_dai || !this.infoDDAT.thong_tin_chung.gia_tri_uu_dai) {
        this.dialogEndow = true;
      } else {
        this.joinTrangVang();
      }
    },
    updateEndow(){
      this.$refs["endowForm"].validate(async (valid) => {
        if (valid) {
          let data = {
            id: this.infoDDAT.id,
            loai_hinh_uu_dai: this.mData.dataFormEndow.loai_hinh_uu_dai,
            gia_tri_uu_dai: parseFloat(this.mData.dataFormEndow.gia_tri_uu_dai)
          };
          try {
            await DDATApi.updateUuDai(data);
            this.joinTrangVang();
            this.dialogEndow = false;
          } catch (error) {
            console.info(error);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    changeTypeEndow(type){
      if (type == "giam_gia_phan_tram") {
        this.mData.validFormEndow.gia_tri_uu_dai = [
          ValidService.required,
          {
            validator: this.validatePercent,
            trigger: "blur"
          }
        ]
      } else {
        this.mData.validFormEndow.gia_tri_uu_dai = [ValidService.required]
      }
      this.mData.dataFormEndow.gia_tri_uu_dai = undefined;
    },
    async joinTrangVang() {
      if (this.infoDDAT &&
          this.infoDDAT.thong_tin_chung &&
          this.infoDDAT.thong_tin_chung.nguoi_dai_dien &&
          this.infoDDAT.thong_tin_chung.nguoi_dai_dien.email) {
        await this.callJoinTrangVang();
      } else {
        this.$prompt('<p>Nhập địa chỉ email</p><small><i>Vui lòng nhập địa chỉ email để nhận thông báo từ Trang vàng</i></small>', 'Tham gia Trang vàng', {
          dangerouslyUseHTMLString: true,
          customClass: 'prompt_join_yellow_page',
          confirmButtonText: 'Tham gia',
          cancelButtonText: 'Đóng',
          inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage: LanguageService.lang.valid_email
        }).then(async ({ value }) => {
          await DonViCungCapChoDuyetApi.updateEmail({
            email: value
          });
          await this.callJoinTrangVang();
        }).catch(() => {
        });
      }
    },
    async callJoinTrangVang() {
      await DonViCungCapChoDuyetApi.registerTrangVang();
      this.isAccountDuLichJoin = false;
      this.$store.commit("fn_refreshMenu");
    }
  },
  mounted: function() {
    AuthService.me().then( async (res) => {
      let currentUserId = res.result.id;
      let dataFilter = {
        filters: "nguoi_tao_id=" + currentUserId
      }
      let diemDenAnToanRes = await DDATApi.list(dataFilter);
      this.infoDDAT = diemDenAnToanRes.result[0];
      if(res.result.roles.includes('SafePlace')){
        if (
          diemDenAnToanRes.result[0].loai_diem_den == "hotel"||
          diemDenAnToanRes.result[0].loai_diem_den == "restaurant" ||
          diemDenAnToanRes.result[0].loai_diem_den == "entertainment" ||
          diemDenAnToanRes.result[0].loai_diem_den == "ticket" ||
          diemDenAnToanRes.result[0].loai_diem_den == "tourist_villa" ||
          diemDenAnToanRes.result[0].loai_diem_den == "tourist_apartment" ||
          diemDenAnToanRes.result[0].loai_diem_den == "camping" ||
          diemDenAnToanRes.result[0].loai_diem_den == "motel" ||
          diemDenAnToanRes.result[0].loai_diem_den == "homestay" ||
          diemDenAnToanRes.result[0].loai_diem_den == "tourist_cruise"
        ) {
          let donViCungCapChoDuyetRes = await DonViCungCapChoDuyetApi.list({
            filters: "id=" + diemDenAnToanRes.result[0].id
          });
          let donViCungCapRes = await DonViCungCapApi.list({
            filters: "id=" + diemDenAnToanRes.result[0].id
          });
          if (!donViCungCapChoDuyetRes.result[0] && !donViCungCapRes.result[0]) {
            this.isAccountDuLichJoin = true;
            this.$msgbox({
              message: 'Bạn chưa đăng ký tham gia Trang vàng. Vui lòng đọc và đồng ý các điều khoản của chúng tôi. Sau đó bấm tham gia để tham gia Trang vàng.',
              customClass: 'join_yellow_page_box',
              confirmButtonText: 'Đóng',
              showClose: false,
              center: true
            });
          }
        }
      }
    })
  }
}
</script>
<style scoped>
::v-deep .endow .el-dialog__body{
  padding: 15px;
}
.card{
    max-width: 80%;
    margin: 0 auto;
}
.card-body .container{
    text-align: justify;
}
.card-body .container .title{
    text-align: center;
    margin-top: 15px;
    text-transform: uppercase;
}
.card-body .container li{
    font-size: 17px;
}
</style>
<style>
  .join_yellow_page_box {
    padding: 30px 20px;
    border-width: 4px;
    border-color: #356ab6;
    border-radius: 10px;
    width: 450px;
  }
  .join_yellow_page_box .el-message-box__content {
    padding: 0;
    margin-bottom: 20px;
  }
  .join_yellow_page_box p {
    text-align: left;
    font-size: 16px;
    font-weight: 500;
  }

  .prompt_join_yellow_page .el-message-box__header {
    background-color: #f0f3f5;
    border-bottom: 1px solid #c8ced3;
  }
  .prompt_join_yellow_page .el-message-box__headerbtn {
    top: 10px;
  }
</style>
